import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import Ticket from 'models/ticket/ticket.model';
import Project from 'models/project/project.model';
import GeoJSONPoint from 'models/geojson-point/geojson-point.model';
import { TicketService } from 'services/ticket/ticket.service';
import { ProjectService } from 'services/project/project.service';

@Component({
  selector: 'app-selected-ticket',
  templateUrl: './selected-ticket.component.html',
  styleUrls: ['./selected-ticket.component.scss'],
})
export class SelectedTicketComponent implements OnInit, OnDestroy {
  @Input() project: Project = new Project();
  @Input() pointsToShow: BehaviorSubject<GeoJSONPoint<{}>[]> = new BehaviorSubject([]);
  filteredPoints: BehaviorSubject<Ticket[]> = new BehaviorSubject([]);
  public canUpdate: boolean = false;

  private ticketSubscription: Subscription;
  private ticketListSubscription: Subscription;
  @Input() public refSubject = new BehaviorSubject<boolean>(false);

  constructor(
    public ticketService: TicketService,
    public projectService: ProjectService,
  ) { }

  async ngOnInit() {
    this.ticketSubscription = this.ticketService.getSelectedInstance().subscribe(async (tickets) => {
      let points = [];
      for (let ticket of tickets) {
        if (ticket.position.geometry.coordinates) {
          this.canUpdate = await this.ticketService.canUpdate(ticket);
          points.push(ticket.position);
        }
      };
      this.pointsToShow.next(points);
    });

    this.ticketListSubscription = this.ticketService.getSelectedList().subscribe(async (tickets) => {
      this.filteredPoints.next(tickets.docs);
    });
  }

  ngOnDestroy() {
    if (this.ticketSubscription) {
      this.ticketSubscription.unsubscribe();
    }
    if (this.ticketListSubscription) {
      this.ticketListSubscription.unsubscribe();
    }
  }
}
